<template>
    <v-col class="py-0 pt-2">
        <div class="d-flex">
            <v-icon color="black" class="mr-2">mdi-bank-transfer</v-icon>
            <p class="subtitle-2 mt-1 mb-0">Sort Code</p>
        </div>
        <div class="d-flex justify-space-between">
            <p class="subtitle-1 mb-0 font-weight-bold">
                {{ recipientInfo.sort_code }}
            </p>
            <v-btn
                @click="copyToClipboard(recipientInfo.sort_code)"
                absolute
                x-small
                class="warning copy-button mt-1"
            >
                Copy
            </v-btn>
        </div>
    </v-col>
</template>

<script>
    export default {
        name: "match-confirmed-reveal-field-sort-code",
        props: {
            recipientInfo: Object
        }
    }
</script>
